export function validateCNPJ( cnpj ) {
    
    const cnpjWeight1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    const cnpjWeight2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    let total = 0, i = 0, verifiedDigit = 0

    cnpjWeight1.forEach(digit => {
        total += digit * Number(cnpj[i])
        i++
    })
    let mod = Number(total % 11)
    if (!(mod < 2)) {
        verifiedDigit = 11 - mod
    }
    if (!( Number(cnpj[12]) === Number(verifiedDigit))) {
        return false
    }
    total = verifiedDigit = i = mod = 0

    cnpjWeight2.forEach(digit => {
        total += digit * Number(cnpj[i])
        i++
    })

    mod = Number(total % 11)
    if (!(mod < 2)) {
        verifiedDigit = 11 - mod
    }
    if (!( Number(cnpj[13]) === Number(verifiedDigit))) {
        return false
    }
    return true
}


// WEBPACK FOOTER //
// ./src/components/parts/document-component/validate-cnpj.js